import 'scss/services/cloudDoctor.scss'
import 'babel-polyfill'
import {
  serviceQA,
  serviceTopbar
} from 'js/libs/utils-services'
import { config } from 'config'
import * as userApi from 'js/api/user'
import { showLoginModal } from 'js/libs/utils-login'
$(function () {
  serviceQA()
  serviceTopbar()
  $('#applyNow').click(function () {
    userApi.checkLogin().then(result => {
      if (result.code === 80000) {
        showLoginModal()
      } else {
        window.open(`${config.CONSOLE}workorder/commit?category=60d3cb76241b40da8d278257f5a9a7b3&tid=b002bf578b6a4c31be42138440cdad6e&categoryName=云医声&tname=商务接洽&title=云医声 - 服务申请&id=cloudDoctor`)
      }
    })
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/services/cloudDoctor.js